"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationChannelForm = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _zod2 = require("zod");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../hooks/useTranslations_simplified-registration-BrandPartner");
var _interfaces = require("../../interfaces");
var _models = require("../../models");
var _api = require("../../models/api");
var _utils = require("../../utils");
var _StepsStyledComponents = require("./StepsStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const StyledSubTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  height: '80px',
  marginBottom: theme.spacing(10),
  textAlign: 'center'
}));
const SubmitButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(10)
}));
const StyledForm = (0, _mui.styled)('form')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '500px',
  marginTop: theme.spacing(8)
}));
const StyledGridContainer = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  marginBottom: theme.spacing(10)
}));
const useGetSchema = config => {
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  if (!config) {
    return _zod2.z.object({});
  }
  const {
    email,
    telephone
  } = config;
  let schema = _zod2.z.object({});
  schema = _zod2.z.object({
    contactEmail: (0, _utils.createFieldSchema)(formatMessage, email, 'string', undefined, 'email'),
    contactTelephone: (0, _utils.createFieldSchema)(formatMessage, telephone, 'string', undefined, 'phone')
  });
  return schema;
};
const VerificationChannelForm = props => {
  const {
    handlePrimaryChannel
  } = props;
  const {
    data: contactMetadata
  } = (0, _api.useContactMetadata)();
  const {
    data: contactData
  } = (0, _api.useContactData)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const validationSchema = useGetSchema(contactMetadata);
  const methods = (0, _reactHookForm.useForm)({
    reValidateMode: 'onSubmit',
    mode: 'onBlur',
    resolver: (0, _zod.zodResolver)(validationSchema)
  });
  const {
    formState
  } = methods;
  const {
    isSubmitting
  } = formState;
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    registrationId
  } = (0, _contexts.useConfiguration)();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    setErrorData,
    customErrors
  } = errorData;
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const isEmailVerification = contactMetadata?.email?.isAvailable;
  const handleSubmitChannel = async data => {
    const correctData = {
      ...data,
      isContactVerified: Boolean(contactData?.isContactVerified)
    };
    try {
      const updateContactResponse = await (0, _globalApiClientReact.updateCustomerRegistrationContactDetails)(api, registrationId, correctData);
      const result = new _models.FetchResult(updateContactResponse.status);
      if (result.isSuccess()) {
        handlePrimaryChannel();
      }
    } catch (error) {
      const errorResponse = error;
      if (errorResponse.response?.status === _globalApiClientReact.HttpStatusCodes.status400BadRequest) {
        const {
          Errors
        } = errorResponse.response.data;
        const submitErrors = Errors?.map(er => ({
          fieldName: er.PropertyName,
          errorCode: er.Code
        }));
        if (submitErrors?.length && submitErrors.length > 0) {
          setErrorData(submitErrors);
        } else {
          setErrorData([]);
        }
      } else {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.cannotUpdate,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotUpdate
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
  };
  const content = isEmailVerification ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledGridContainer, {
    container: true,
    justifyContent: "center",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12,
        sm: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepsStyledComponents.StyledTitle, {
        variant: "h4",
        color: "textPrimary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.EmailPrimaryChannelTitle,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.EmailPrimaryChannelTitle
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12,
        sm: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubTitle, {
        variant: "subtitle1",
        color: "textPrimary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.EmailPrimaryChannelDescription,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.EmailPrimaryChannelDescription
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      enableLowercaseLetters: true,
      name: "contactEmail",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.EmailPrimaryChannelLabel,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.EmailPrimaryChannelLabel
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.EmailPrimaryChannelTooltip,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.EmailPrimaryChannelTooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.EmailPrimaryChannelPlaceholder),
      keyboardType: "email",
      ...contactMetadata.email,
      isMandatory: contactMetadata.email?.validation?.isMandatory,
      maxLengthLimit: contactMetadata.email?.validation?.maxLength,
      customErrors: customErrors
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledGridContainer, {
    container: true,
    justifyContent: "center",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12,
        sm: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepsStyledComponents.StyledTitle, {
        variant: "h4",
        color: "textPrimary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.PhonePrimaryChannelTitle,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhonePrimaryChannelTitle
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12,
        sm: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubTitle, {
        variant: "subtitle1",
        color: "textPrimary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.PhonePrimaryChannelDescription,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhonePrimaryChannelDescription
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
      name: "contactTelephone",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PhonePrimaryChannelLabel,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhonePrimaryChannelLabel
      }),
      labelWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PhonePrimaryChannelLabelWithPrefix,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhonePrimaryChannelLabelWithPrefix
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PhonePrimaryChannelTooltip,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhonePrimaryChannelTooltip
      }),
      helperTextWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PhonePrimaryChannelTooltipWithPrefix,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhonePrimaryChannelTooltipWithPrefix
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.PhonePrimaryChannelPlaceholder),
      customPlaceholderWithPrefix: formatMessage(_models.TranslationKey.PhonePrimaryChannelPlaceholderWithPrefix),
      ...contactMetadata?.telephone,
      isMandatory: contactMetadata?.telephone?.validation?.isMandatory,
      customErrors: customErrors
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
    ...methods,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledForm, {
      noValidate: true,
      onSubmit: methods.handleSubmit(handleSubmitChannel),
      children: [content, /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitButtton, {
        variant: "contained",
        color: "primary",
        type: "submit",
        disabled: isSubmitting,
        ...getTestIdProps('submit-btn-primaryChannel'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.PrimaryChannelSubmitButton,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PrimaryChannelSubmitButton
        })
      })]
    })
  });
};
exports.VerificationChannelForm = VerificationChannelForm;